export default {"src":"/_next/static/media/1on1_mobile_img_sub_01.9255b908.svg","height":350,"width":375};